import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * Standard search input used across list pages.
 * - Kebab-cased data-testid via `testId` prop for E2E.
 * - Shows a clear button when non-empty.
 */
const SearchBar = ({ value, onChange, placeholder = 'Buscar…', testId = 'search-input', className = '' }) => (
  <div className={`relative flex-1 min-w-[200px] ${className}`}>
    <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none"/>
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      className="w-full bg-[#0a0a0a] border border-white/10 text-white text-sm rounded-xl pl-10 pr-9 py-2.5 focus:outline-none focus:border-[#A3FF12] placeholder:text-white/30"
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        data-testid={`${testId}-clear`}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-white/40 hover:text-white p-1"
        aria-label="Limpiar búsqueda">
        <X size={14}/>
      </button>
    )}
  </div>
);

// Utility for consistent, accent-insensitive matching across fields.
export const matches = (query, ...fields) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  const norm = (v) => (v == null ? '' : String(v)).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const nq = norm(q);
  return fields.some((f) => norm(f).includes(nq));
};

export default SearchBar;
